import React from 'react'
import { Field } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import ModalBody from 'app/components/Modal/ModalBody'
import TextArea from 'app/components/TextArea'
import Button from 'app/components/ButtonDefault'
import { required, minLength } from 'helpers/validators'
import { WHY_YOU_STOP_PROTRACK_FORM_NAME } from 'app/constants/profile'

import './styles.scss'
const baseClass = 'stop-protrack-popup'

const FormModal = ({ t, onRequestClose, handleSubmit, selectedProTrackName, submitting, form }) => {
  return (
    <ModalBody
      className={baseClass}
      onRequestClose={onRequestClose}
      title={
        <span>
          {t(
            `user:Help us get better by telling us your reason for ${
              form === WHY_YOU_STOP_PROTRACK_FORM_NAME ? 'stopping' : 'switching'
            }`
          )}{' '}
          <b>{selectedProTrackName}</b>.
        </span>
      }
    >
      <form onSubmit={handleSubmit}>
        <Field component={TextArea} name="reason" validate={[required(), minLength(5)]} />

        <div className={`${baseClass}__footer`}>
          <Button
            type="submit"
            primary
            className={`${baseClass}__button`}
            submitting={submitting}
            disabled={submitting}
          >
            {t('Submit')}
          </Button>
          <Button type="button" onClick={onRequestClose} className={`${baseClass}__button`}>
            {t('Cancel')}
          </Button>
        </div>
      </form>
    </ModalBody>
  )
}

FormModal.displayName = 'FormModal'

export default withTranslation()(FormModal)
